<div class="profile-layout">
  <div class="user-profile">
    <div class="more-actions">
      <sync-icon-button
      [matTooltip]="'More Actions'"
      [iconName]="'more-vertical'"
      [disabled]="false"
      [onClick]="openMoreActionsMenu"
      ></sync-icon-button>
      <sync-menu #menuComponent [hasBackdrop]="true" [menuItems]="moreActionsItems" [isMenuOpen]="false" (onMenuClick)="onActionClick($event)"></sync-menu>
    </div>
    <sync-avatar [size]="96" [url]="avatarUrl" [initials]="(user.display_name | b64)"></sync-avatar>
    <div class="h2">{{ user.display_name | b64 }}</div>
    <div class="h5">{{ user.email }}</div>
  </div>
  <div class="preview-section">
    <sync-section-header [header]="'Web previews'"
      [description]="'Sync will automatically preview files in your chosen previewer. With Office Online enabled, you can edit and view Microsoft Word documents, Excel spreadsheets, and PowerPoint slideshows from the Sync web panel.'"
      [level]="'h4'"></sync-section-header>
    <sync-list [ListItems]="previewerProps"></sync-list>
  </div>
  <div *ngIf="rewardHistoryList?.referral_code" class="reference-section">
    <div class="h4">Reference code</div>
    <div class="reference-code">
      <span>{{rewardHistoryList?.referral_code}}</span>
      <sync-button *ngIf="rewardHistoryList?.total" [type]="'flat'" [label]="'Rewards history'" [onClick]="openRewardHistoryDialog"></sync-button>
    </div>
  </div>
  <div class="notifications-section">
    <sync-section-header [header]="'Notifications'"
      [description]="'Sync will never sell or share your email address with a third-party.'"
      [level]="'h4'"
      [showButton]="true"
      [showActions]="true"
      [buttonConfig]="{
        label: 'Edit permissions',
        type: 'flat',
        onClick: openNotificationPermissionsDialog,
      }"
      ></sync-section-header>

      <sync-dialog
        [config]="{
          title: 'Notification permissions'
        }"
        [open]="showNotificationPermissionsDialog"
        [onClose]="closeNotificationPermissionsDialog">
        <div class="notifications-modal">
          <sync-list [ListItems]="notificationItems"></sync-list>
        </div>
      </sync-dialog>
  </div>
  <div class="options-section" *ngIf="allowed()">
    <sync-section-header [header]="'Additional options'" [level]="'h4'"></sync-section-header>
    <sync-list [ListItems]="additionalOptions"></sync-list>
  </div>
  <div class="rewardHistoryDialog">
    <sync-dialog [config]="{
        title: 'Rewards history'
        }" [open]="showRewardHistoryDialog" [isFullScreen]="false" [onClose]="closeRewardHistoryDialog">
      <div class="reward-history-list" *ngIf="rewardsHistory?.length">
        <sync-list [ListItems]="rewardsHistory"></sync-list>
      </div>
      <div *ngIf="!rewardsHistory?.length">
        <span class="subtitle-1">No Records</span>
        <p class="subtitle-1">You have not earned any rewards yet.</p>
      </div>
    </sync-dialog>
  </div>
  <div class="manualRedemptionDialog">
    <sync-dialog [config]="{
        title: 'Manual redemption', 
        actionButton: 'Reedem', 
        cancelButton: 'Cancel',
        onActionClick:redeem,
        onCancelClick:closeManualRedemptionDialog,
        isButtonLoading:isButtonLoading,
        isActionButtonDisabled: isRedeemButtonDisabled()
      }"
      [open]="showManualRedemptionDialog"
      [isFullScreen]="false"
      [onClose]="closeManualRedemptionDialog"
      >
      <div class="manualRedemptionDialogBody">
        <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
        <div class="body-1">Enter a referral code to redeem your reward.</div>
        <sync-text-field class="refcode_textfield" [label]="'Referral code'" [value]="referralCode" [inputChange]="refcode" [errorMessage]="redemptionError"></sync-text-field>
      </div>
    </sync-dialog>
  </div>
<sync-dialog [config]="{
    title: 'Previewer',
    isClosable: false,
    actionButton: 'Save',
    cancelButton: 'Cancel', 
    onActionClick: onPreviewSave, 
    onCancelClick: onPreviewClose}" [open]="previewerOpen" [onClose]="onPreviewClose">
<div class="previewer-modal">
  <sync-radio-button-group isLoading="spinner" [radioButtonItems]="previewerOptions" [changeRadioButtonValue]="changeRadioButtonValue" />
</div>
</sync-dialog>

    <app-dialog-display-avatar *ngIf="showAvatarDialog" [(showAvatarDialog)]="showAvatarDialog" [user]="user"></app-dialog-display-avatar>
    <app-dialog-cancel *ngIf="showDeleteDialog" [(showDeleteDialog)]="showDeleteDialog" [user]="user"></app-dialog-cancel>
    <app-dialog-confirm-password *ngIf="showConfirmPasswordDialog" [(showDialog)]="showConfirmPasswordDialog" (action)="onConfirmPassword()"></app-dialog-confirm-password>
    <app-dialog-display-name *ngIf="showNameDialog" [(showNameDialog)]="showNameDialog" [user]="user"></app-dialog-display-name>
    <app-dialog-email-change *ngIf="showEmailDialog" [(showEmailDialog)]="showEmailDialog" [user]="user"></app-dialog-email-change>
</div>
  
  
